module.exports = __webpack_public_path__ + "static/acid-test-286337f8566ebf3685a567c87d7ce07c.jpg";